const PancakeSwapRouter = [
  'function getAmountsOut(uint256 amountIn, address[] memory path) external view returns (uint256[] memory)',
];

export default PancakeSwapRouter;
